import {HomeView} from "./home";
import * as React from "react";
import {useCallback, useState} from "react";
import {usePlatform, useStorageItemValue} from "@variocube/cube-ui";
import {UserView} from "./user/UserView";
import {AdminView} from "./admin/AdminView";
import {LogLevel} from "@variocube/app-api";
import {Tenant} from "./types";

export function App() {
    const platform = usePlatform();

    const tenant = useStorageItemValue<Tenant>("tenant");
    const [admin, setAdmin] = useState<string | undefined>();
    const [user, setUser] = useState<boolean>(false);

    const handleCode = useCallback(async (code: string) => {
        await platform.log(LogLevel.Trace, "handleCode in app.tsx", {code});
        if(tenant && tenant.adminCode == code) {
            setAdmin(tenant.user);
        }else {
            setUser(true);
        }
    }, [tenant]);

    const handleHome = useCallback(() => {
        setAdmin(undefined);
        setUser(false);
    }, []);


    if (user) {
        return <UserView onClose={handleHome} />
    }

    if (admin) {
        return <AdminView onClose={handleHome} />
    }

    return (
        <HomeView onCode={handleCode} />
    )
}
